<template>
	<div class="card card-shadow user-result" :class="{'tw-opacity-50': !is_available}">
		<a :href="is_available ? '/resources/' + course.slug : '#'">
			<div class="card-top top-image">
				<img :src="course.image">
				<div class="tw-absolute tw-top-0 tw-right-0 tw-p-4 tw-opacity-75 tw-text-gray-800" v-if="!is_available">
					<i class="far fa-lock"></i>
				</div>
			</div>
		</a>
		<div class="card-inner">
			<a class="tw-text-gray-700 tw-font-semibold tw-text-base hover:tw-opacity-75" :href="is_available ? '/resources/' + course.slug : '#'">
				{{ course.name }}
			</a>
			<p class="tw-mt-2" v-if="release_date_is_in_future">
				<i class="far fa-clock tw-pr-1"></i>
				{{ translations['membership.available_on'] }} {{ release_date.getDate() }}-{{ release_date.getMonth()+1 }}-{{ release_date.getFullYear() }}
			</p>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
	name: 'SearchCourseCard',

	props: {
		course: {
			required: true,
		},
	},

	computed: {
		...mapState([
			'translations'
		]),

		is_available() {
			return this.course.available && this.course.details_visible;
		},

		release_date() {
			return new Date(this.course.release_date);
		},

		release_date_is_in_future() {
			return this.course.release_date !== null && this.release_date > Date.now();
		},
	},
};
</script>
